prepDropdowns = () => {

  if (globalStorage.firstLoad) {
    document.addEventListener("click", () => {
      if (event.target.classList.toString().includes("dropdown")) return;

      let openDropdowns = document.querySelectorAll(".dropdown.js-dropdown.open");

      if (openDropdowns) {
        openDropdowns.forEach(dropdown => {
          dropdown.classList.remove("open");
          gsap.to(dropdown.querySelector(".js-dropdown-options-wrapper"), { height: 0, duration: 0.4 });
        });
      }
    });
  }

  let dropdowns = document.querySelectorAll(".js-dropdown:not(.bound)");

  let installationKitTriggerWrappers = document.querySelectorAll(".installtion-kit-overlay-trigger-wrapper");

  dropdowns.forEach(dropdown => {
    let dropdownValue = dropdown.querySelector(".js-dropdown-value");
    let optionsWrapper = dropdown.querySelector(".js-dropdown-options-wrapper");
    let options = optionsWrapper.querySelectorAll(".js-dropdown-option");
    let input = dropdown.querySelector("input");

    dropdownValue.addEventListener("click", () => {
      if (dropdown.classList.contains("open")) {
        //close
        gsap.to(optionsWrapper, { height: 0, duration: 0.4 });
        dropdown.classList.remove("open");
      } else {
        //open
        gsap.set(optionsWrapper, { height: "auto" });
        gsap.from(optionsWrapper, { height: 0, duration: 0.4 });
        dropdown.classList.add("open");
      }
    });

    options.forEach(option => {
      option.addEventListener("click", (event) => {

        /* --- Stop if disabled --- */
        if (event.target.classList.contains("disabled")) {
          event.stopPropagation();
          return;
        }

        dropdownValue.children[0].innerHTML = option.children[0].innerHTML;
        if (input) { input.value = option.children[0].innerHTML; }
        gsap.to(optionsWrapper, { height: 0, duration: 0.4 });
        dropdown.classList.remove("open");

        // If there are triggers to open Installation Kit Overlay, only show when "Peel and Stick" selected
        if (dropdown.dataset.option != "material") return;

        let material = encodeURI(option.children[0].innerHTML);
        material = material.trim();

        if (material != "Peel%20and%20Stick") {
          installationKitTriggerWrappers.forEach(wrapper => {
            wrapper.classList.add("hidden-kit");
          });
        } else {
          installationKitTriggerWrappers.forEach(wrapper => {
            wrapper.classList.remove("hidden-kit");
          });
        }

        if (!installationKitTriggerWrappers) return;
      });
    });
  });
};